
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  // Component Data
  data: function () {
    // Must return an object
    return {
      stationList: [],
      age: 25,
      like: ["Tennis", "Chess", "Football"]
    };
  },
  // Component Methods
  methods: {
    location: function (_stationList) {
      var self = this; //    self.$app.dialog.alert('');

      if (!navigator.geolocation) return false;
      navigator.geolocation.getCurrentPosition(position => {
        const {
          longitude,
          latitude
        } = position.coords;
        const sortedArray = sortByLoc([longitude, latitude], _stationList); //   logg(".searchStationByLocation")("Sorted stations: ", sortedArray);

        this.$setState({
          stationList: sortedArray
        });
      }, () => {//   iPointerApp.F7.alert("שגיאה בקבלת מיקום");
      });

      const sortByLoc = ([longitude, latitude], positions = []) => {
        for (let i = 0; i < positions.length; i++) {
          if (positions[i].pws_CoordinateX > 0) {
            var distance = calculateDistance(parseFloat(positions[i].pws_CoordinateX), parseFloat(positions[i].pws_CoordinateY), latitude, longitude);
            positions[i].distance = distance;
          }
        }

        positions.sort(function (a, b) {
          return a.distance - b.distance;
        });
        return positions;
      };

      const calculateDistance = (lat1, lon1, lat2, lon2, unit) => {
        var radlat1 = Math.PI * lat1 / 180;
        var radlat2 = Math.PI * lat2 / 180;
        var radlon1 = Math.PI * lon1 / 180;
        var radlon2 = Math.PI * lon2 / 180;
        var theta = lon1 - lon2;
        var radtheta = Math.PI * theta / 180;
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        dist = Math.acos(dist);
        dist = dist * 180 / Math.PI;
        dist = dist * 60 * 1.1515;

        if (unit == "K") {
          dist = dist * 1.609344;
        }

        if (unit == "N") {
          dist = dist * 0.8684;
        }

        return dist;
      };
    }
  },
  on: {
    pageMounted: function (e, page) {
      console.log("pageMounted", page);
    },
    pageInit: function (e, page) {
      var searchbar = app.f7.searchbar.create({
        el: ".searchbar",
        searchContainer: ".list",
        searchIn: ".item-title-row ,.item-subtitle",
        on: {
          search(sb, query, previousQuery) {
            console.log(query, previousQuery);
          }

        }
      });

      var _this = this;

      app.f7.request.get("https://fleet.pointer4u.co.il/iservices/iPointerAPIv10/api/getInstallStationAll", function (data) {
        var jsonData = JSON.parse(data);
        var _stationList = jsonData.root.InstallStation;

        _this.$setState({
          stationList: _stationList
        });

        setTimeout(function () {
          _this.$app.dialog.confirm("האם להציג תחנות שירות קרובות למיקום שלי?", "פוינטר", function () {
            _this.$app.$("#locationButton").trigger("click");
          });
        }, 100);
        /*
                                    _stationList.forEach(function (item) {
                                        console.log(item);
                                    });
                
                
                              
                */
      });
    }
  },
  id: '51f6bfb2f9',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\r\n  <div class="page" data-name="home">\r\n    <!-- Top Navbar -->\r\n    <div class="navbar">\r\n      <div class="navbar-bg"></div>\r\n      <div class="navbar-inner">\r\n        <div class="title">\r\n          <img src="static/Pointer_Logo_black.png" alt="פוינטר" />\r\n        </div>\r\n\r\n        <div class="subnavbar">\r\n          <form class="searchbar">\r\n            <div class="searchbar-inner">\r\n              <div class="searchbar-input-wrap">\r\n                <input type="search" placeholder="חיפוש תחנת שירות" />\r\n                <i class="searchbar-icon"></i>\r\n                <span class="input-clear-button"></span>\r\n              </div>\r\n            </div>\r\n          </form>\r\n          <div\r\n            id="locationButton"\r\n            @click="location(stationList)"\r\n            style="width: 60px; height: 50px; background-color: #fff"\r\n          >\r\n            <div style="margin: 5px auto; width: 25px; color: #737373">\r\n              <i style="font-size: 22px" class="icon f7-icons">location</i>\r\n\r\n              <span\r\n                style="\r\n                  font-size: 10px;\r\n                  position: absolute;\r\n                  top: 32px;\r\n                  width: 60px;\r\n                  left: 0px;\r\n                "\r\n                ><span style="text-align: center; display: block"\r\n                  >קרוב אלי</span\r\n                ></span\r\n              >\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <!-- Toolbar-->\r\n    <div class="toolbar toolbar-bottom">\r\n      <div class="toolbar-inner">\r\n        <a\r\n          style="border-radius: 0; width: 100%"\r\n          class="col button button-large button-raised button-fill external"\r\n          href="tel:0732288555"\r\n          >חייג למוקד שירות פוינטר</a\r\n        >\r\n      </div>\r\n    </div>\r\n    <!-- Scrollable page content-->\r\n    <div class="page-content">\r\n      <div class="block-title">תחנות שירות פוינטר</div>\r\n      <div class="list media-list">\r\n        <ul>\r\n          ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.stationList, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\r\n          <li class="accordion-item">\r\n            <a href="#" class="item-link item-content">\r\n              <!--<div class="item-media"><img src="http://fleet.pointer4u.co.il/iPointerAPP/Content/images/iconPointer60.png" width="50" /></div>-->\r\n              <div class="item-inner">\r\n                <div class="item-title-row">\r\n                  <div>\r\n                    <b> ';
          r += c(ctx_2.HebrewName, ctx_2);
          r += '</b>\r\n\r\n                    <br />\r\n\r\n                    ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.skills.split(','), {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\r\n\r\n                    <div class="chip">\r\n                      <div class="chip-label">';
              r += c(ctx_3, ctx_3);
              r += '</div>\r\n                    </div>\r\n                    ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\r\n                  </div>\r\n                </div>\r\n                <div class="item-subtitle">\r\n                  ';
          r += c(ctx_2.pws_CityIdName, ctx_2);
          r += ' , ';
          r += c(ctx_2.pws_Address, ctx_2);
          r += '\r\n                </div>\r\n                <div class="item-text">';
          r += c(ctx_2.pws_Telephone1, ctx_2);
          r += '</div>\r\n              </div>\r\n            </a>\r\n            <div class="accordion-item-content">\r\n              <div class="block">\r\n                <p class="row">\r\n                  <a\r\n                    class="col button button-raised button-fill external"\r\n                    href="tel:';
          r += c(ctx_2.pws_Telephone1, ctx_2);
          r += '"\r\n                    >התקשר</a\r\n                  >\r\n                  <a\r\n                    class="col button button-raised button-fill external"\r\n                    href="waze://?ll=';
          r += c(ctx_2.pws_CoordinateX, ctx_2);
          r += ',';
          r += c(ctx_2.pws_CoordinateY, ctx_2);
          r += '&navigate=yes"\r\n                    >ניווט</a\r\n                  >\r\n                </p>\r\n              </div>\r\n            </div>\r\n          </li>\r\n          ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\r\n        </ul>\r\n      </div>\r\n    </div>\r\n  </div>\r\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    